<div id="content" class="extensible">
  <div class="page-title">
    <h1>{{ page_title }}</h1>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      @if (is_rrhh_or_admin()) {
        <mat-form-field appearance="outline" class="bisual-paginator-select">
          <mat-label>Responsable</mat-label>
          <mat-select formControlName="responsible_user_id">
            <mat-option [value]="''">Todas</mat-option>
            <mat-option [value]="current_user_id">Las que gestiono yo</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="bisual-paginator-select">
          <mat-label>Estado</mat-label>
          <mat-select formControlName="status">
            <mat-option [value]="''">Todos</mat-option>
            @for (s of st; track s) {
              <mat-option [value]="s.status">
                {{ s.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-left: auto"
      >
      </mat-paginator>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="data_source">
        <ng-container matColumnDef="clock_type">
          <th mat-header-cell *matHeaderCellDef>Tipo</th>
          <td mat-cell *matCellDef="let crrr">
            <div class="clock-type-cell">
              <mat-icon
                [matTooltip]="crrr.meta_data?.type === 'out' ? 'Fichaje de salida' : 'Fichaje de entrada'"
                [ngStyle]="
                  crrr.meta_data?.type === 'out' ? { transform: 'rotate(180deg)', color: 'var(--warn-color)' } : { color: 'var(--green)' }
                "
              >
                trending_flat
              </mat-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let crrr">
            <mat-icon>{{ crrr.id }}</mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="user_name">
          <th mat-header-cell *matHeaderCellDef>Trabajador</th>
          <td mat-cell *matCellDef="let crrr">
            {{ crrr.meta_data.user_name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="justification">
          <th mat-header-cell *matHeaderCellDef>Justificación</th>
          <td mat-cell *matCellDef="let crrr">{{ crrr.justification }}</td>
        </ng-container>

        <ng-container matColumnDef="original">
          <th mat-header-cell *matHeaderCellDef>Original</th>
          <td mat-cell *matCellDef="let crrr">
            <div class="change-cell">
              @if (crrr.has_date_changed) {
                <span>{{ crrr.meta_data.current_date | date: 'dd-MM-yy HH:mm' }}</span>
              }
              @if (crrr.has_location_changed) {
                @if (crrr.meta_data?.original_location_name && crrr.original_location) {
                  <button
                    type="button"
                    mat-button
                    class="location-button"
                    (click)="openLocationDialog(crrr.original_location)"
                    matTooltip="Ver ubicación en el mapa"
                  >
                    <mat-icon>place</mat-icon>
                    <span>{{ crrr.meta_data.original_location_name }}</span>
                  </button>
                } @else {
                  <span>—</span>
                }
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="proposed">
          <th mat-header-cell *matHeaderCellDef>Propuesta</th>
          <td mat-cell *matCellDef="let crrr">
            <div class="change-cell">
              @if (crrr.has_date_changed) {
                <span>{{ crrr.proposed_date | date: 'dd-MM-yy HH:mm' }}</span>
              }
              @if (crrr.has_location_changed) {
                @if (crrr.meta_data?.proposed_location_name && crrr.proposed_location) {
                  <button
                    type="button"
                    mat-button
                    class="location-button"
                    (click)="openLocationDialog(crrr.proposed_location)"
                    matTooltip="Ver ubicación en el mapa"
                  >
                    <mat-icon>place</mat-icon>
                    <span>{{ crrr.meta_data.proposed_location_name }}</span>
                  </button>
                } @else {
                  <span>—</span>
                }
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="difference">
          <th mat-header-cell *matHeaderCellDef>Diferencia</th>
          <td mat-cell *matCellDef="let crrr">
            @if (crrr.date_difference) {
              {{ crrr.date_difference }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let crrr; let i = index">
            <div class="actions-cell">
              <button mat-icon-button (click)="openApprovalStatusDialog(crrr)" matTooltip="Estado de aprobación">
                <mat-icon>info</mat-icon>
              </button>
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
            </div>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                (click)="approve(crrr.id)"
                [disabled]="crrr.status !== employee_request_responsible_for_answer_status_enum.PENDING"
              >
                <mat-icon matPrefix>check</mat-icon>
                Aprobar solicitud
              </button>
              <button
                mat-menu-item
                (click)="reject(crrr.id)"
                [disabled]="crrr.status !== employee_request_responsible_for_answer_status_enum.PENDING"
              >
                <mat-icon matPrefix>close</mat-icon>
                Rechazar solicitud
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayed_columns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayed_columns"></tr>
      </table>
    </div>
  </div>
</div>
